import { CheckCircle2 } from "lucide-react";
import { BIO } from "@/data/site";
import Reveal from "@/components/Reveal";

const About = () => (
  <section id="about" className="bg-navy-900 py-16 sm:py-24">
    <div className="container-x grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
      <Reveal className="relative order-2 lg:order-1">
        <div className="absolute -inset-2 rounded-[2rem] border border-teal-500/20" aria-hidden="true" />
        <img
          data-testid="about-photo"
          src="/media/coach.jpg"
          alt="صورة المدرب"
          loading="lazy"
          className="relative aspect-[4/5] w-full rounded-3xl object-cover object-[25%_30%] ring-1 ring-white/10 sm:aspect-[5/4] lg:aspect-[4/5]"
        />
      </Reveal>

      <div className="order-1 lg:order-2">
        <Reveal>
          <p className="mb-3 text-sm font-semibold text-teal-400">{BIO.eyebrow}</p>
          <h2 data-testid="about-title" className="text-2xl font-bold leading-snug sm:text-3xl lg:text-4xl">
            {BIO.title}
          </h2>
        </Reveal>
        <Reveal delay={0.08}>
          {BIO.paragraphs.map((p, i) => (
            <p key={i} className="mt-5 leading-loose text-ink-soft sm:text-lg">
              {p}
            </p>
          ))}
        </Reveal>
        <Reveal delay={0.14}>
          <ul className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {BIO.specialties.map((s) => (
              <li key={s} className="flex min-h-[44px] items-center gap-2.5 text-sm font-medium sm:text-base">
                <CheckCircle2 className="h-5 w-5 shrink-0 text-teal-400" />
                {s}
              </li>
            ))}
          </ul>
          <p className="mt-8 text-xs text-ink-mute">{BIO.placeholderNote}</p>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
